import { render, staticRenderFns } from "./Recipe_Tab_Carousel.vue?vue&type=template&id=3bb0e8a2&scoped=true&"
import script from "./Recipe_Tab_Carousel.vue?vue&type=script&lang=js&"
export * from "./Recipe_Tab_Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Recipe_Tab_Carousel.vue?vue&type=style&index=0&id=3bb0e8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0e8a2",
  null
  
)

export default component.exports